import React, { Component } from "react";
import Radium from "radium";
import { connect } from "react-redux";
import * as actions from "./actions";
import DatePickerRange from "../../../Common/datepickerRange";
import NumberInput from "../../../Common/numberInput";
import { Scrollbars } from "react-custom-scrollbars";
import { semanticColors, greyScaleColors } from "../../../Globals/styles";
import { httpGet } from "../../../Util/http";

import auth from "../../../Login/authService";
import SuggestSelectInput from "../../../Common/suggestSelectInput";

class PCalc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      extraProjects: [{}],
    };
  }
  componentWillUnmount = () => {
    this.props.dispatch(actions.cleanup());
  };
  getStade = () => {
    const { project, dispatch } = this.props;
    dispatch(
      actions.getPcalcProject(project.id, this.state.start, this.state.end)
    );
  };

  getStadeProjects = (ids) => {
    const { project, dispatch } = this.props;
    const extraProjects = ids.filter((e) => e.id);
    dispatch(
      actions.getPcalcProjects(
        [project.id, ...extraProjects.map((p) => p.id)],
        this.state.start,
        this.state.end
      )
    );
    this.setState({ extraProjects });
  };

  pcalc = () => {
    const { dispatch, params } = this.props;
    let start = this.state.start;
    let end = this.state.end;
    dispatch(actions.getPcalc(params.workplaceId, start, end));
  };

  filterPcalc = (showNotInvoicedOnly) => {
    const { project, dispatch, params, stade } = this.props;

    if (stade === true) {
      dispatch(
        actions.getPcalcProject(
          project.id,
          this.state.start,
          this.state.end,
          showNotInvoicedOnly
        )
      );
    } else {
      dispatch(
        actions.getPcalc(
          params.workplaceId,
          this.state.start,
          this.state.end,
          showNotInvoicedOnly
        )
      );
    }
  };

  render() {
    const {
      params,
      dispatch,
      isLoading,
      isStatusOK,
      pCalc,
      crewRates,
      materiels,
      client,
      project,
      workplaceName,
      stade,
      showNotInvoicedOnly,
    } = this.props;
    var totalSum = 0;
    let activitiesIsOdd = true;
    let _url = "";
    if (this.state.start && this.state.end) {
      let token = auth.getToken();
      let dateFrom = JSON.parse(JSON.stringify(this.state.start));
      let dateTo = JSON.parse(JSON.stringify(this.state.end));
      _url =
        process.env.REACT_APP_webApiEndPoint +
        "api/dailyreport/printmultipleperiod?workplaceId=" +
        params.workplaceId +
        "&dateFrom=" +
        dateFrom +
        "&dateTo=" +
        dateTo +
        "&token=" +
        token;
    }

    var filterPcalcClassName = showNotInvoicedOnly
      ? "btn btn-info waves-effect"
      : "btn btn-default waves-effect";
    return (
      <div style={styles.container}>
        <div style={styles.datepickerContainer}>
          <div className="row">
            <div style={{ position: "absolute", top: 14 }}>
              <div
                className={filterPcalcClassName}
                onClick={() => {
                  if (this.state.start && this.state.end) {
                    this.filterPcalc(!showNotInvoicedOnly);
                  }
                }}
                style={{ zIndex: 10000, "@media print": { display: "none" } }}
              >
                Vis kun ikke faktureret
              </div>
            </div>
            <div style={{ marginLeft: 65 }}>
              <DatePickerRange
                onChange={(start, end) => {
                  dispatch(actions.getPcalc(params.workplaceId, start, end));
                  this.setState({ start, end });
                }}
              />
            </div>
            <div style={styles.status}>
              {isLoading ? (
                <i className="fa fa-spinner fa-spin fa-2x" />
              ) : isStatusOK ? (
                <i className="fa fa-check fa-2x" />
              ) : (
                <i className="fa fa-exclamation-triangle fa-2x" />
              )}
            </div>
          </div>
        </div>
        {!this.state.start ? (
          <div style={styles.emptyState}>
            <img
              style={styles.img}
              alt="Ingen periode er valgt"
              src="/images/emptyStates/pkalk_ingenperiode.png"
            />
          </div>
        ) : pCalc.measurements.length +
            pCalc.deliverynotes.length +
            pCalc.usage.length +
            pCalc.crew.length +
            pCalc.activities.length ===
          0 ? (
          <div style={styles.emptyState}>
            <img
              style={styles.img}
              alt="Der er ingen registreret dagrapporter i den valgte periode"
              src="/images/emptyStates/pkalk_ingenregdagrapporter.png"
            />
          </div>
        ) : (
          <Scrollbars
            className="scrollbars"
            style={{ height: "100%", width: "100%" }}
            renderView={(props) => (
              <div {...props} className="scrollbarsView" />
            )}
          >
            {/*OriginData*/}
            {client ? (
              <div>
                {stade ? (
                  <div style={styles.entityContainer}>
                    <div style={{ textAlign: "center" }}>
                      <h2>
                        Stadeopgørelse for sag: {project.number} -{" "}
                        {project.name}{" "}
                      </h2>
                      <p
                        style={{
                          "@media print": { display: "none" },
                          cursor: "pointer",
                        }}
                        onClick={this.pcalc}
                      >
                        klik her for at gå tilbage til pkalk
                      </p>
                      <div>
                        <div>
                          <label style={{ marginRight: 6 }}>Ekstra Sager</label>
                        </div>
                        {this.state.extraProjects.map((p, i) => (
                          <div>{p.name}</div>
                        ))}
                        <div
                          style={{
                            "@media print": { display: "none" },
                            cursor: "pointer",
                          }}
                        >
                          <SuggestSelectInput
                            onChange={(value) => {
                              this.setState({ searchQuery: value.name });
                            }}
                            onQuery={(q) => {
                              var fetchUrl =
                                process.env.REACT_APP_webApiEndPoint +
                                `api/project/search?query=${q}&all=true`;
                              if (!q) {
                                this.setState({
                                  projectSuggestions: [],
                                });
                                return;
                              }
                              return httpGet(fetchUrl)
                                .then((response) => {
                                  return response.json();
                                })
                                .then((json) => {
                                  this.setState({
                                    projectSuggestions: json,
                                  });
                                })
                                .catch((e) => {
                                  console.log(e);
                                });
                            }}
                            suggestions={this.state.projectSuggestions || []}
                            value={{ name: this.state.searchQuery || "" }}
                            placeholder="Tilføj sag"
                            onSelect={(proj) => {
                              console.log(proj);
                              this.getStadeProjects([
                                ...this.state.extraProjects,
                                proj,
                              ]);
                              this.setState({
                                searchQuery: "",
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div style={styles.entityContainer}>
                    <div className="row" style={styles.doubleLine}>
                      <div className="col-xs-5" style={styles.stamdata.col}>
                        <h3>
                          Sag
                          <span
                            onClick={this.getStade}
                            style={{
                              "@media print": {
                                display: "none",
                              },
                              paddingRight: 2,
                              paddingLeft: 2,
                              fontSize: 12,
                              marginLeft: 5,
                              color: "#fff",
                              backgroundColor: "#A8CEDC",
                              cursor: "pointer",
                              borderRadius: 2.25,
                            }}
                          >
                            Klik her for stade
                          </span>
                        </h3>
                      </div>
                      <div className="col-xs-4" style={styles.stamdata.col}>
                        <h3>Bygherre</h3>
                      </div>
                      <div className="col-xs-3" style={styles.stamdata.col}>
                        <h3>ID / Arbejdssted</h3>
                      </div>
                    </div>
                    <div className="row" style={styles.stamdata.row}>
                      <div className="col-xs-5" style={styles.stamdata.col}>
                        {project.number} <br />
                        {project.name}
                      </div>
                      <div className="col-xs-4" style={styles.stamdata.col}>
                        {client.name} <br />
                        {client.contactName}
                      </div>
                      <div className="col-xs-3" style={styles.stamdata.col}>
                        {workplaceName}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : null}

            {/* CREW */}
            {pCalc.crew.length === 0 ? null : (
              <div>
                <div style={styles.title}>Mandskab</div>
                <div style={styles.table}>
                  <div style={styles.theader}>
                    <div
                      className="col-xs-4 text-left"
                      style={styles.noPadding}
                    >
                      Funktion
                    </div>
                    <div
                      className="col-xs-3 text-left"
                      style={styles.noPadding}
                    >
                      Normal
                    </div>
                    <div
                      className="col-xs-3 text-left"
                      style={styles.noPadding}
                    >
                      Overtid/Nat
                    </div>
                    <div
                      className="col-xs-2 text-right"
                      style={styles.noPadding}
                    >
                      Sum
                    </div>
                  </div>
                  <div style={styles.tbody}>
                    <div style={styles.subHeadder}>
                      <div className="col-xs-2 col-xs-offset-3">
                        <div className="col-xs-6 text-right">Timer</div>
                        <div className="col-xs-6 text-right">Pris</div>
                      </div>
                      <div className="col-xs-3">
                        <div className="col-xs-6 text-right">Timer</div>
                        <div className="col-xs-6 text-right">Pris</div>
                      </div>
                    </div>
                    {pCalc.crew.map((c, index) => {
                      var sum =
                        c.normal * crewRates[c.function]["normalRate"] +
                        c.night * crewRates[c.function]["nightRate"];
                      totalSum += sum;
                      /*There is a mismatch between the API employeeFunctions
                            and the client employeeFunctions defined in
                            Globals/constants/employeeFunctions*/
                      var empFunction = c.function;
                      if (empFunction === "RopeAccessSupervisor") {
                        empFunction = "Rope-access Supervisor";
                      } else if (empFunction === "RopeAccessWorker") {
                        empFunction = "Rope-access Worker";
                      }
                      return (
                        <div
                          style={[styles.tr, index % 2 !== 0 && styles.trOdd]}
                          key={c.function}
                        >
                          <div className="col-xs-3" style={styles.td}>
                            {empFunction}
                          </div>
                          <div
                            className="col-xs-1 text-right"
                            style={styles.td}
                          >
                            {c.normal}
                          </div>
                          <div
                            className="col-xs-1 text-right"
                            style={[styles.td]}
                          >
                            <NumberInput
                              onChange={(val) =>
                                dispatch(
                                  actions.updateCrew(
                                    c.function,
                                    "normalRate",
                                    val
                                  )
                                )
                              }
                              value={crewRates[c.function]["normalRate"]}
                            />
                          </div>
                          <div
                            className="col-xs-offset-1 col-xs-1 text-right"
                            style={styles.td}
                          >
                            {c.night}
                          </div>
                          <div
                            className="col-xs-1 text-right"
                            style={[styles.td]}
                          >
                            <NumberInput
                              onChange={(val) =>
                                dispatch(
                                  actions.updateCrew(
                                    c.function,
                                    "nightRate",
                                    val
                                  )
                                )
                              }
                              value={crewRates[c.function]["nightRate"]}
                            />
                          </div>
                          <div
                            className="col-xs-4 text-right"
                            style={styles.td}
                          >
                            {sum}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}

            {/* Aktiviteter */}
            {pCalc.activities.length === 0 ? null : (
              <div>
                <div style={styles.title}>Aktiviteter</div>
                <div style={styles.table}>
                  <div style={styles.theader}>
                    <div className="col-xs-5" style={styles.noPadding}>
                      Art
                    </div>
                    <div className="col-xs-1 col-xs-offset-4 text-right">
                      Timer
                    </div>
                    <div
                      className="col-xs-1 text-right"
                      style={styles.noPadding}
                    >
                      Pris
                    </div>
                    <div
                      className="col-xs-1 text-right"
                      style={styles.noPadding}
                    >
                      Sum
                    </div>
                  </div>
                  <div style={styles.tbody}>
                    {pCalc.activities.map((a, i) => {
                      let price = a.price ? a.price : 0;
                      let sum = a.totalHours * price;
                      totalSum += sum;
                      activitiesIsOdd = !activitiesIsOdd;

                      return (
                        <div
                          style={[styles.tr, activitiesIsOdd && styles.trOdd]}
                          key={a.activityGroupName}
                        >
                          <div
                            className="col-xs-5"
                            style={[styles.td, styles.mainActivityLabel]}
                          >
                            {a.activityGroupName}
                          </div>
                          <div
                            className="col-xs-1 col-xs-offset-4 text-right"
                            style={styles.mainActivityLabel}
                          >
                            {a.totalHours}
                          </div>
                          <div
                            className="col-xs-1 text-right"
                            style={[styles.td, styles.noPadding]}
                          >
                            <NumberInput
                              onChange={(val) =>
                                dispatch(actions.updateActivitiesPrice(i, val))
                              }
                              value={price}
                            />
                          </div>
                          <div
                            className="col-xs-1 text-right"
                            style={[styles.td, styles.mainActivityLabel]}
                          >
                            {sum}
                          </div>
                          {a.subActivities.map((subActivity) => {
                            activitiesIsOdd = !activitiesIsOdd;
                            return (
                              <div
                                key={subActivity.name}
                                style={[
                                  styles.tr,
                                  activitiesIsOdd && styles.trOdd,
                                ]}
                              >
                                <div
                                  className="col-xs-5"
                                  style={styles.subActivityLabel}
                                >
                                  {subActivity.name === ""
                                    ? "Ingen beskrivelse"
                                    : subActivity.name}
                                </div>
                                <div className="col-xs-1 col-xs-offset-4 text-right">
                                  {subActivity.hours}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}

            {/* Materiel */}
            {pCalc.usage.length === 0 ? null : (
              <div>
                <div style={styles.title}>Materiel</div>
                <div style={styles.table}>
                  <div style={styles.theader}>
                    <div className="col-xs-5" style={styles.noPadding}>
                      Art
                    </div>
                    <div className="col-xs-1">Antal</div>
                    <div className="col-xs-1 col-xs-offset-1">Enhed</div>
                    <div
                      className="col-xs-1 col-xs-offset-2 text-right"
                      style={styles.noPadding}
                    >
                      Pris
                    </div>
                    <div
                      className="col-xs-1 text-right"
                      style={styles.noPadding}
                    >
                      Sum
                    </div>
                  </div>
                  <div style={styles.tbody}>
                    {pCalc.usage.map((m, index) => {
                      var sum = 0;
                      if (materiels[m.id].type !== "Materiel") {
                        return false;
                      } else {
                        sum += m.amount * materiels[m.id].price;
                        totalSum += sum;
                        return (
                          <div
                            style={[styles.tr, index % 2 !== 0 && styles.trOdd]}
                            key={m.id}
                          >
                            <div className="col-xs-5" style={styles.td}>
                              {materiels[m.id].name}
                            </div>
                            <div
                              className="col-xs-1 text-center"
                              style={styles.td}
                            >
                              {m.amount}
                            </div>
                            <div
                              className="col-xs-1 col-xs-offset-1 text-center"
                              style={styles.td}
                            >
                              {materiels[m.id].unit}
                            </div>
                            <div
                              className="col-xs-1 col-xs-offset-2"
                              style={[styles.td, styles.noPadding]}
                            >
                              <NumberInput
                                onChange={(val) =>
                                  dispatch(
                                    actions.updateMaterielPrice(m.id, val)
                                  )
                                }
                                value={materiels[m.id].price}
                              />
                            </div>
                            <div
                              className="col-xs-1 text-right"
                              style={styles.td}
                            >
                              {sum}
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              </div>
            )}

            {/* Materiale */}
            {pCalc.usage.length === 0 ? null : (
              <div>
                <div style={styles.title}>Materiale</div>
                <div style={styles.table}>
                  <div style={styles.theader}>
                    <div className="col-xs-5" style={styles.noPadding}>
                      Art
                    </div>
                    <div className="col-xs-1">Antal</div>
                    <div className="col-xs-1 col-xs-offset-1">Enhed</div>
                    <div
                      className="col-xs-1 col-xs-offset-2 text-right"
                      style={styles.noPadding}
                    >
                      Pris
                    </div>
                    <div
                      className="col-xs-1 text-right"
                      style={styles.noPadding}
                    >
                      Sum
                    </div>
                  </div>
                  <div style={styles.tbody}>
                    {pCalc.usage.map((m, index) => {
                      var sum = 0;
                      if (materiels[m.id].type !== "Materiale") {
                        return false;
                      } else {
                        sum += m.amount * materiels[m.id].price;
                        totalSum += sum;
                        return (
                          <div
                            style={[styles.tr, index % 2 === 0 && styles.trOdd]}
                            key={m.id}
                          >
                            <div className="col-xs-5" style={styles.td}>
                              {materiels[m.id].name}
                            </div>
                            <div
                              className="col-xs-1 text-center"
                              style={styles.td}
                            >
                              {m.amount}
                            </div>
                            <div
                              className="col-xs-1 col-xs-offset-1 text-center"
                              style={styles.td}
                            >
                              {materiels[m.id].unit}
                            </div>
                            <div
                              className="col-xs-1 col-xs-offset-2"
                              style={[styles.td, styles.noPadding]}
                            >
                              <NumberInput
                                onChange={(val) =>
                                  dispatch(
                                    actions.updateMaterielPrice(m.id, val)
                                  )
                                }
                                value={materiels[m.id].price}
                              />
                            </div>
                            <div
                              className="col-xs-1 text-right"
                              style={styles.td}
                            >
                              {sum}
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              </div>
            )}

            {/* DELIVERYNOTES */}
            {pCalc.deliverynotes.length === 0 ? null : (
              <div>
                <div style={styles.title}>Følgesedler</div>
                <div style={styles.table}>
                  <div style={styles.theader}>
                    <div className="col-xs-2" style={styles.noPadding}>
                      Nummer
                    </div>
                    <div className="col-xs-2" style={styles.noPadding}>
                      Leverandør
                    </div>
                    <div
                      className="col-xs-4 col-xs-offset-1"
                      style={styles.noPadding}
                    >
                      Specifikation
                    </div>
                    <div className="col-xs-1 text-right">Pris</div>
                    <div
                      className="col-xs-1 text-right"
                      style={styles.noPadding}
                    >
                      Tillæg %
                    </div>
                    <div
                      className="col-xs-1 text-right"
                      style={styles.noPadding}
                    >
                      Sum
                    </div>
                  </div>
                  <div style={styles.tbody}>
                    {pCalc.deliverynotes.map((d, i) => {
                      var price = d.price ? d.price : 0;
                      var procentage = d.procentage ? d.procentage : 0;
                      let sum = price * (procentage / 100 + 1);
                      let roundedSum = Math.round(sum * 100) / 100;
                      totalSum += roundedSum;
                      return (
                        <div
                          style={[styles.tr, i % 2 !== 0 && styles.trOdd]}
                          key={i}
                        >
                          <div className="col-xs-2" style={styles.td}>
                            {d.number}
                          </div>
                          <div className="col-xs-2 text-left" style={styles.td}>
                            {d.supplier}
                          </div>
                          <div
                            className="col-xs-4 col-xs-offset-1"
                            style={styles.td}
                          >
                            {d.specification}
                          </div>
                          <div
                            className="col-xs-1 text-center"
                            style={[styles.td]}
                          >
                            <NumberInput
                              onChange={(val) =>
                                dispatch(
                                  actions.updateDeliverynotePrice(i, val)
                                )
                              }
                              value={price}
                            />
                          </div>
                          <div
                            className="col-xs-1 text-center"
                            style={[styles.td, styles.noPadding]}
                          >
                            <NumberInput
                              onChange={(val) =>
                                dispatch(
                                  actions.updateDeliverynoteProcentage(i, val)
                                )
                              }
                              value={procentage}
                            />
                          </div>
                          <div
                            className="col-xs-1 text-right"
                            style={styles.td}
                          >
                            {roundedSum}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}

            {/* MEASUREMENTS */}
            {pCalc.measurements.length === 0 ? null : (
              <div>
                <div style={styles.title}>Opmåling</div>
                <div style={styles.table}>
                  <div style={styles.theader}>
                    <div className="col-xs-2" style={styles.noPadding}>
                      Type
                    </div>
                    <div className="col-xs-1" style={styles.noPadding}>
                      Antal
                    </div>
                    <div className="col-xs-2" style={styles.noPadding}>
                      Længde (cm)
                    </div>
                    <div className="col-xs-1" style={styles.noPadding}>
                      Dybde
                    </div>
                    <div className="col-xs-4" style={styles.noPadding}>
                      Område
                    </div>
                    <div
                      className="col-xs-1  text-right"
                      style={styles.noPadding}
                    >
                      Pris
                    </div>
                    <div
                      className="col-xs-1 text-right"
                      style={styles.noPadding}
                    >
                      Sum
                    </div>
                  </div>
                  <div style={styles.tbody}>
                    {pCalc.measurements.map((d, i) => {
                      var price = d.price ? d.price : 0;
                      var sum = d.amount * price;
                      totalSum += sum;
                      return (
                        <div
                          style={[styles.tr, i % 2 !== 0 && styles.trOdd]}
                          key={i}
                        >
                          <div className="col-xs-2" style={styles.td}>
                            {d.type}
                          </div>
                          <div className="col-xs-1" style={styles.td}>
                            {d.amount}
                          </div>
                          <div className="col-xs-2" style={styles.td}>
                            {d.length}
                          </div>
                          <div className="col-xs-1" style={styles.td}>
                            {d.depth}
                          </div>
                          <div className="col-xs-4" style={styles.td}>
                            {d.area}
                          </div>
                          <div
                            className="col-xs-1 text-right"
                            style={[styles.td, styles.noPadding]}
                          >
                            <NumberInput
                              onChange={(val) =>
                                dispatch(actions.updateMeasurementPrice(i, val))
                              }
                              value={price}
                            />
                          </div>
                          <div
                            className="col-xs-1 text-right"
                            style={styles.td}
                          >
                            {sum}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}

            <div style={styles.footer}>
              <div style={styles.print}>
                {!stade ? (
                  <div className="" style={{ marginRight: 12 }}>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={_url}
                      style={{ color: "#4a4a4a" }}
                    >
                      <i
                        className="fa fa-file-text-o"
                        style={{ fontSize: 24, marginRight: 5 }}
                      />
                      Print dagrapporter for valgte periode{" "}
                    </a>
                  </div>
                ) : null}
                |
                <div
                  className=""
                  onClick={window.print}
                  style={{ cursor: "pointer", marginLeft: 12 }}
                >
                  <i
                    className="fa fa-print"
                    style={{ fontSize: 24, marginRight: 5 }}
                  />
                  Udskriv pkalk
                </div>
              </div>
              <div style={styles.footerSum}>
                <span style={styles.sumPris}>Sum pris</span>
                {totalSum}
              </div>
            </div>
          </Scrollbars>
        )}
      </div>
    );
  }
}

var styles = {
  scrollbars: {
    "@media print": {
      paddingRight: "10px",
    },
  },
  container: {
    width: "100%",
    height: "100%",
    paddingTop: "110px",
    position: "relative",
    "@media (min-width: 1200px)": {
      position: "relative",
      marginLeft: "auto",
      marginRight: "auto",
      maxWidth: "1170px",
      width: "100%",
    },
  },
  datepickerContainer: {
    position: "absolute",
    top: "30px",
    left: "0",
    right: "0",
  },
  table: {
    width: "100%",
    marginBottom: "15px",
  },
  theader: {
    height: "20px",
    width: "100%",
    borderBottom: "1px solid",
    borderColor: semanticColors.mainBackground,
  },
  tbody: {
    display: "inline-block",
    width: "100%",
    height: "100%",
  },
  title: {
    fontWeight: "bold",
    marginBottom: "10px",
  },
  subHeadder: {
    width: "100%",
    height: "20px",
  },
  td: {
    padding: "0px 5px",
    minHeight: "35px",
    lineHeight: "35px",
  },
  tr: {
    backgroundColor: "#EBEEF0",
    marginTop: "2px",
    width: "100%",
    minHeight: "35px",
    lineHeight: "35px",
    overflow: "auto",
    "@media print": {
      borderBottom: "1px solid",
      borderColor: greyScaleColors.greyLighter,
    },
  },
  trOdd: {
    backgroundColor: semanticColors.primaryLight,
  },
  th: {
    display: "inline-block",
    width: "25%",
    padding: "0px",
  },
  noPadding: {
    padding: "0px",
  },
  status: {
    position: "absolute",
    top: "20px",
    right: "13px",
    "@media print": {
      display: "none",
    },
  },
  print: {
    display: "flex",
    "@media print": {
      display: "none",
    },
  },
  footer: {
    width: "100%",
    borderColor: semanticColors.mainBackground,
  },
  footerSum: {
    textAlign: "right",
    fontWeight: "600",
    padding: "15px 0px 30px 0px",
    borderTop: "1px solid",
  },
  sumPris: {
    marginRight: "100px",
  },
  img: {
    margin: "0 auto",
    display: "block",
  },
  mainActivityLabel: {
    fontWeight: "600",
  },
  subActivityLabel: {
    paddingLeft: "25px",
  },
  stamdata: {
    row: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      margin: "0",
      paddingLeft: "4px",
      lineHeight: "25px",
    },
    col: {
      paddingLeft: "0",
    },
  },
  entityContainer: {
    marginTop: "20px",
    marginBottom: "20px",
  },
  doubleLine: {
    borderBottom: "4px double " + semanticColors.mainBackground,
    lineHeight: "1.2em",
    margin: "0",
    padding: "4px 0",
  },
};

const selectProps = (state) => {
  return {
    ...state.PCalcReducer,
    workplace: state.workplaceOverviewReducer.workplace,
  };
};

export default connect(selectProps)(Radium(PCalc));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/PCalc/index.jsx